import React, { useContext } from 'react';

import PageTitle from '../../components/page-title/PageTitle';
import EpisodeCard from '../../components/episode-card/EpisodeCard';
import PreviewThumbnail from '../../assets/img/thumbnail.png';

import { FavoritesContext } from '../../contexts/favorites.context';

import {
  FavoritePodcastContainer,
  PodcastCardContainer,
  SubscribeButton,
  NoShowsContainer
} from './FavoritesPage.styled';

const FavoritesPage = () => {
  const { favorites } = useContext(FavoritesContext);

  return (
    <div>
      <PageTitle>Favorites</PageTitle>
      {favorites.length ? (
        <FavoritePodcastContainer>
          {favorites.map(podcast => (
            <PodcastCardContainer
              key={podcast.id}
              style={{ position: 'relative' }}
            >
              <EpisodeCard podcast={podcast} />
              <SubscribeButton id={podcast.id} />
            </PodcastCardContainer>
          ))}
        </FavoritePodcastContainer>
      ) : (
        <NoShowsContainer>
          <img src={PreviewThumbnail} alt="how to favorite" />
          <p>Find your favorite shows and save them for quick access</p>
        </NoShowsContainer>
      )}
    </div>
  );
};

export default FavoritesPage;
